// extracted by mini-css-extract-plugin
export var bulb = "ItemStatus-module--bulb--yo1C9";
export var container = "ItemStatus-module--container--QAlPK";
export var label = "ItemStatus-module--label--Zg8NM";
export var textWrapper = "ItemStatus-module--textWrapper--30E6Q";